import { isGlobalFeatureEnabled } from "owa-feature-flags";

export function isBizChatCachingEnabled(targetWindow?: Window): boolean {
    return ((!targetWindow || targetWindow === window) &&
        isGlobalFeatureEnabled("mon-copilot-bizchat-caching"));
}
